import { createSlice } from "@reduxjs/toolkit";

import {
  setSelectedStrategyReducer,
  setSelectedPortfolioReducer,
  setPortfolioSearchValueReducer,
  setActiveStrategiesReducer,
  setShowAddFundsModalReducer,
  setShowStatusModalReducer,
  setSelectedPortfolioIdsReducer,
} from "./reducer";

const initialState = {
  tradingDetail: {},
  selectedStrategy: {},
  selectedPortfolio: {},
  activeStrategies: {
    data: [],
    isLoading: false,
    isSubLoading: false,
    totalPages: 0,
    totalCount: 0,
  },
  portfolioSearchValue: "",
  showAddFundsModal: false,
  showStatusModal: "",
  selectedPortfolioIds: [],
};

export const portfolioSlice = createSlice({
  name: "portfolio",
  initialState,
  reducers: {
    setSelectedStrategy: setSelectedStrategyReducer,
    setSelectedPortfolio: setSelectedPortfolioReducer,
    setPortfolioSearchValue: setPortfolioSearchValueReducer,
    setActiveStrategies: setActiveStrategiesReducer,
    setShowAddFundsModal: setShowAddFundsModalReducer,
    setShowStatusModal: setShowStatusModalReducer,
    setSelectedPortfolioIds: setSelectedPortfolioIdsReducer,
  },
});

export const {
  setSelectedStrategy,
  setSelectedPortfolio,
  setPortfolioSearchValue,
  setActiveStrategies,
  setShowAddFundsModal,
  setShowStatusModal,
  setSelectedPortfolioIds,
} = portfolioSlice.actions;

export default portfolioSlice.reducer;
